import React, { FunctionComponent } from 'react';
import {
  SchemaBlock,
  ISchemaBlockProps
} from '../../schema-block/schema-block';
import styles from './progress-step-content.module.scss';

export interface IProgressStepContentProps {
  columnText1: string;
  columnText2: string;
  schemaBlocks: ISchemaBlockProps[];
}

export const ProgressStepContent: FunctionComponent<IProgressStepContentProps> = ({
  columnText1,
  columnText2,
  schemaBlocks
}) => {
  return (
    <div className={styles.stepContent}>
      <div className={styles.columnsWrapper}>
        <div
          className={styles.column}
          dangerouslySetInnerHTML={{ __html: columnText1 }}
        ></div>
        <div dangerouslySetInnerHTML={{ __html: columnText2 }}></div>
      </div>
      <div className={styles.schema}>
        {schemaBlocks.map((block, i) => (
          <SchemaBlock {...block} key={i} />
        ))}
      </div>
    </div>
  );
};
